import React, { FC, memo, useEffect } from 'react';
import routes from '../../constants/routes';
import useCustomRouter from '@hooks/useCustomRouter';
import { useDispatch } from 'react-redux';
import { NETWORK_STATUS_DONE, NETWORK_STATUS_ERROR } from 'src/redux/redux.interface';
import { useUserDuck } from '@hooks/useUserDuck';
import { SidebarMenu } from '../MyAccountMenu';

export const MyAccountSidebar: FC = memo(() => {
    const {
        summary: { accountStatus, accountError },
        FetchMyAccountSummary,
    } = useUserDuck();

    const dispatch = useDispatch();
    const router = useCustomRouter();

    useEffect(() => {
        if (accountStatus === null) {
            dispatch(FetchMyAccountSummary);
        }
    }, [dispatch, FetchMyAccountSummary, accountStatus]);

    if (accountStatus === NETWORK_STATUS_ERROR) {
        if (accountError.code === 403) {
            router.replace(routes.LOGIN);
        } else {
            // todo: Unhandled error, send error to logger
            console.error('Unhandled error', accountError);
        }

        return <div />;
    }

    if (accountStatus === NETWORK_STATUS_DONE) {
        return <SidebarMenu />;
    }

    // todo: show spinner
    return <div />;
});
MyAccountSidebar.displayName = 'MyAccountSidebar';
